export default "__VITE_ASSET__CVsCL1j8__"